import React, { FC, useRef } from "react";
import type { OriginatingInstitutionsDelightCustomersProps } from "@/types";
import { ContentManager } from "../content-manager";
import { Cta } from "../cta";
import { useInView } from "@/hooks/reveal-in-view";
import SplitTextAnimation from "../split-text-animation";

export const OriginatingInstitutionsDelightCustomers: FC<OriginatingInstitutionsDelightCustomersProps> = ({
  content,
  cards,
  cta,
}) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "0px 0px 25% 0px" });
  return (
    <section className="originatingInstitutionsDelightCustomers">
      <div className="wrapper">
        <SplitTextAnimation
          htmlElement={
            <ContentManager
              content={content}
              className="originatingInstitutionsDelightCustomers--content"
              style={{
                transform: isInView ? "none" : `translateY(20px)`,
                opacity: isInView ? 1 : 0,
                transition: "all 0.5s cubic-bezier(0.17, 0.55, 0.55, 1)",
              }}
            />
          }
          isInView={isInView}
        />
      </div>
      <div className="wrapper wrapper_lg" ref={ref}>
        <div className="originatingInstitutionsDelightCustomers--cards">
          {cards.map((card, index) => {
            return (
              <div
                key={index}
                className="originatingInstitutionsDelightCustomers--card"
                style={{
                  transform: isInView
                    ? "none"
                    : `translateY(${20 * (index + 1)}px)`,
                  opacity: isInView ? 1 : 0,
                  transition: `all 0.5s cubic-bezier(0.17, 0.55, 0.55, 1) ${
                    index * 0.1
                  }s`,
                }}
                onMouseEnter={(event) => {
                  const target = event.currentTarget as HTMLElement;
                  target.classList.add("hover-animation-bounce");
                }}
                onAnimationEnd={(event) => {
                  const target = event.target as HTMLElement;
                  target.classList.remove("hover-animation-bounce");
                }}
              >
                {card.title && (
                  <ContentManager
                    content={card.title}
                    className="originatingInstitutionsDelightCustomers--card-title"
                    style={{
                      transform: isInView
                        ? "none"
                        : `translateY(${20 * (index + 1)}px)`,
                      opacity: isInView ? 1 : 0,
                      transition: `all 0.5s cubic-bezier(0.17, 0.55, 0.55, 1) ${
                        index * 0.1
                      }s`,
                    }}
                  />
                )}
                {card.description && (
                  <ContentManager
                    content={card.description}
                    className="originatingInstitutionsDelightCustomers--card-description"
                    style={{
                      transform: isInView
                        ? "none"
                        : `translateY(${20 * (index + 1)}px)`,
                      opacity: isInView ? 1 : 0,
                      transition: `all 0.5s cubic-bezier(0.17, 0.55, 0.55, 1) ${
                        index * 0.1
                      }s`,
                    }}
                  />
                )}
              </div>
            );
          })}
        </div>
        {/* TODO: Temporary hidden */}
        {/* <Cta
          cta={cta}
          className="originatingInstitutionsDelightCustomers--cta"
        /> */}
      </div>
    </section>
  );
};
